/**
 * Promo codes on a membership-options quote. Whether a code is real is answered by
 * checkpromocode; the save reports nothing about one it refused. Matched without case.
 */

export type QuotePromoCodeGuard = {
  allowed: boolean;
  error: string;
};

const sameCode = (a: string, b: string) => a.toLowerCase() === b.toLowerCase();

/**
 * Whether a code may be sent at all, before checkpromocode is asked. Not capped: a code evicts
 * those on the subjects it covers, so a quote never holds more codes than it has subjects.
 */
export const canApplyQuotePromoCode = (
  code: string,
  held: string[]
): QuotePromoCodeGuard => {
  if (!code.trim()) {
    return { allowed: false, error: '' };
  }

  if (held.some((existing) => sameCode(existing, code))) {
    return { allowed: false, error: 'This promo code has already been added' };
  }

  return { allowed: true, error: '' };
};
